module.exports = __webpack_public_path__ + "img/apc-cards-mobile.86bdff09.jpg";